// extracted by mini-css-extract-plugin
module.exports = {"closer":"CloserButton_closer__6rNOi"};